const __WEBPACK_NAMESPACE_OBJECT__ = require("rehype-external-links");